import * as Yup from "yup";

export function initialValues(document) {
  return {
    title: document?.title || "",
    year: document?.year || new Date().getFullYear(),
    description: document?.description || "",
    file: null,
  };
}

export function validationSchema(document) {
  return Yup.object({
    title: Yup.string().required("El título es obligatorio"),
    year: Yup.number()
      .typeError("El año debe ser un número")
      .required("El año es obligatorio")
      .integer("El año debe ser un número entero")
      .min(2000, "El año no es válido")
      .max(2100, "El año no es válido"),
    description: Yup.string(),
    // En creación el archivo es obligatorio; en edición es opcional.
    file: document
      ? Yup.mixed().nullable()
      : Yup.mixed().required("El archivo PDF es obligatorio"),
  });
}
